// extracted by mini-css-extract-plugin
module.exports = {"container":"Banner_container__28PAh","image":"Banner_image__3GhAH"};